export default {
  altitudePreview: {
    expandAltitudeChart: 'Extindeți graficul',
    altitude: 'Altitudine',
  }
}
